<template>
  <div :class="classes" v-loading.fullscreen.lock="loading" :element-loading-text="loadingText">
    <pt-page-title :title="currentTitle"></pt-page-title>
    <div class="tip">
      已选择任务单：<span>{{this.selectedOrder.length}}</span>
    </div>
    <!-- 批量操作内容 -->
    <component v-if="hasForm" ref="child" @input="val=>form = val" :status="action"  :is="action"  :loadingText="loadingText" ></component>
    <pt-sub-title :title="subTitle">
      <el-button type="text" slot="line" style="margin-left:10px;" @click="showDialig = true">点击查看已勾选数据</el-button>
    </pt-sub-title>
    <!-- 列表 -->
    <ptProductionTaskList
      ref="table"
      hideTitle 
      hasComplete
      noDownLoad
      :isLot="true"
      :status="targetData.otherParams.status"
      :isReceiveExamData="targetData.otherParams.isReceiveExamData"
      :isOrderBack="targetData.otherParams.isOrderBack"
      @updateSelectData="updateSelectData"
      @getAllSize="(val)=>allSize = val"
    ></ptProductionTaskList>
    <div class="button-div" >
      <el-button type="primary" @click="save">提交</el-button>
      <el-button type="primary" plain @click="cancel">取消</el-button>
      
    </div>

    <!-- 查看已勾选数据 -->
    <selected-data-dialog :dialogVisible="showDialig" :tableData="selectedOrder" @updateVisible="(val)=>showDialig = val"></selected-data-dialog>

  </div>
</template>

<script>
  import { TaskStatus} from 'cps/trust-deed/pt-lot-operate-choice-dialog/choice'
  import BILL_CHECKED from 'cps/trust-deed/order-status/form/BILL_CHECKED'
  import BILL_RECEIVE from 'cps/trust-deed/order-status/form/BILL_RECEIVE'
  import selectedDataDialog from './selected-data-dialog'
  import ptProductionTaskList from 'cps/production-task/pt-production-task-list'
  import { next } from 'cps/lab-order/order-status/status'
// 组件class前缀
const prefixCls = 'pt-task-lot-operate'

export default {
  name: 'pt-task-lot-operate',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    subTitle () {
      return '已勾选任务单（' + this.selectedOrder.length + '/' + this.allSize + '）'
    },
    targetData(){
      return TaskStatus.find(e=>e.name === this.$route.params.status)
    },
    action(){
      return this.targetData.action
    },
    orderStatusResult(){
      return this.targetData.otherParams.orderStatusResult
    },
    currentTitle () {
      return `批量${this.targetData.name}`
    },
    hasForm () {
      const noForm = ['ORDER_GET', 'ORDER_EXAM', 'REPORT_CREATE', 'REPORT_CHECKED']
      return !noForm.includes(this.action)
    },
  },
  props: {
  },
  data () {
    return {
      allSize: '',
      loading: false,
      loadingText: '正在处理中，请稍后',
      selectedOrder: [],
      showDialig:false,
      form:null
    }
  },
  
  components: {
    BILL_CHECKED,
    BILL_RECEIVE,
    selectedDataDialog,
    ptProductionTaskList
    // LAB_DNA_READY,
    // INDEX_BUILD,
    // DATA_ANALYSISED,
    // REPORT_CHECKED_1ST,
    // LAB_DNA_TESTED,
    // DATA_RETURN,
    // CHIP_SLOT,
    // SAMPLE_RETURNED,
    // AMPLIFICATION,
    // DYE_AND_SCAN,
    // LIBRARY_QUALITY_INSPECT
  },
  methods: {
    cancel () {
      history.go(-1)
    },
    save(){
      if(!this.selectedOrder.length){
        this.$message.warning('请先勾选委托单')
        return
      }

      this.loading = true
      let dataCurrent = {
        productionTaskTrigger:true,
        taskIds: this.selectedOrder.map(e=>e.id),
        action: this.action,
        orderStatusDetail: {
          action: this.action,
          orderStatusResult:this.orderStatusResult
        }
      }
      
      next.call(this, dataCurrent,true).then(res => {
        this.$refs.table.reload()
        this.selectedOrder = []
      }).catch(err => {
        this.$message.error(err.message || err)
      }).finally(()=>{
        this.loading = false
      })
    },
    updateSelectData(data){
      this.selectedOrder = data
    }
  },
  created () {
   
  }
}
</script>

<style lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
@import "~less/var.less";
.pt-task-lot-operate {
  .tip{
    font-size:18px;
    margin:20px 0;
    span{
      font-size:20px;
      font-weight:bold;
      color: @mainColor;
    }
  }
  .received-title {
    //本样式在子组件中使用
    font-size: 1rem;
    margin-top: 0.5rem;
  }
  .el-upload-list {
    max-width: 800px;
  }
  .statistics {
    font-size: 22px;
    font-weight: normal;
    span.num {
      font-size: 30px;
      font-weight: bold;
      color: #0a4a94;
    }
  }
  .info-tip {
    //本样式在子组件中使用
    color: red;
    font-size: 12px;
    padding: 10px 0;
  }
  .operate-buttons {
    margin: 40px 0 30px;
  }
  .selected {
    .checkboxList {
      margin-top: 20px;
      position: relative;
    }
  }
}
</style>
